import React, { useState } from 'react';
import { ChevronDown, ArrowLeft } from 'lucide-react';
import './paymentTest2.css';

export default function PromotionOrderPanel({ initialPlan = 'Basic', onBack }) {
    const [selectedPlan, setSelectedPlan] = useState(initialPlan);
    const [isPlanDropdownOpen, setIsPlanDropdownOpen] = useState(false);

    const plans = [
        { id: 'Basic', name: 'Basic', price: 0 },
        { id: 'Standard', name: 'Standard', price: 9 },
        { id: 'Visibility+', name: 'Visibility+', price: 19 }, // Przykład ceny
        { id: 'Premium', name: 'Premium', price: 29 }
    ];

    const currentPlanData = plans.find(p => p.id === selectedPlan) || plans[0];

    const [includeAllEvents, setIncludeAllEvents] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        nip: '',
        companyName: '',
        street: '',
        postalCode: '',
        city: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const total = currentPlanData.price;
    const vatRate = 0.23;
    const basePrice = total / (1 + vatRate) ;
    const vat = basePrice * vatRate;

    return (
        <>

            <div className="promotion-order-panel">
                <div className="container">
                    <div className="content-wrapper">
                        <button className="back-button" onClick={onBack}>
                            <ArrowLeft size={20} />
                            Powrót
                        </button>

                        <div className="grid">
                            {/* Lewa kolumna - Formularz */}
                            <div className="form-panel">
                                <h2 className="main-title">Zamówienie promowania</h2>
                                <p className="description">
                                    Uzupełnij dane, aby zrealizować zamówienie. Na podany adres e-mail wyślemy fakturę do osiągniętego planu.
                                </p>

                                {/* Sekcja 1: Wybrane promowanie */}
                                <div className="section">
                                    <h3 className="section-title">1. Wybrane promowanie</h3>
                                    <div style={{ position: 'relative' }}>
                                        <button
                                            className="select-button"
                                            onClick={() => setIsPlanDropdownOpen(!isPlanDropdownOpen)}
                                        >
                                            <span>{selectedPlan}</span>
                                            <ChevronDown size={20} />
                                        </button>

                                        {isPlanDropdownOpen && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                backgroundColor: 'white',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                marginTop: '4px',
                                                zIndex: 10,
                                                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                                            }}>
                                                {plans.map(plan => (
                                                    <div
                                                        key={plan.id}
                                                        onClick={() => {
                                                            setSelectedPlan(plan.id);
                                                            setIsPlanDropdownOpen(false);
                                                        }}
                                                        style={{
                                                            padding: '12px 16px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #f3f4f6'
                                                        }}
                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                    >
                                                        {plan.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Sekcja 2: Wybrane wydarzenie */}
                                <div className="section">
                                    <h3 className="section-title">2. Wybrane wydarzenie</h3>
                                    <p className="event-name">Nazwa wydarzenia</p>
                                    <label className="checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={includeAllEvents}
                                            onChange={(e) => setIncludeAllEvents(e.target.checked)}
                                        />
                                        <span>Promuj wszystkie wydarzenia</span>
                                    </label>
                                </div>

                                {/* Sekcja 3: Twoje dane */}
                                <div className="section">
                                    <h3 className="section-title">3. Twoje dane</h3>
                                    <div className="form-fields">
                                        <div className="input-row">
                                            <input
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                placeholder="Imię"
                                                className="input-field"
                                            />
                                            <input
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                placeholder="Nazwisko"
                                                className="input-field"
                                            />
                                        </div>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            placeholder="Numer telefonu"
                                            className="input-field full-width"
                                        />
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder="Adres e-mail"
                                            className="input-field full-width"
                                        />
                                    </div>
                                </div>

                                {/* Sekcja 4: Dane do faktury */}
                                <div className="section">
                                    <h3 className="section-title invoice-title">
                                        <span className="invoice-icon"></span>
                                        Faktura
                                    </h3>
                                    <div className="form-fields">
                                        <input
                                            type="text"
                                            name="nip"
                                            value={formData.nip}
                                            onChange={handleInputChange}
                                            placeholder="NIP"
                                            className="input-field full-width"
                                        />
                                        <input
                                            type="text"
                                            name="companyName"
                                            value={formData.companyName}
                                            onChange={handleInputChange}
                                            placeholder="Nazwa firmy"
                                            className="input-field full-width"
                                        />
                                        <input
                                            type="text"
                                            name="street"
                                            value={formData.street}
                                            onChange={handleInputChange}
                                            placeholder="Ulica i numer"
                                            className="input-field full-width"
                                        />
                                        <div className="input-row">
                                            <input
                                                type="text"
                                                name="postalCode"
                                                value={formData.postalCode}
                                                onChange={handleInputChange}
                                                placeholder="Kod pocztowy"
                                                className="input-field"
                                            />
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                placeholder="Miasto"
                                                className="input-field"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Prawa kolumna - Podsumowanie */}
                            <div className="summary-column">
                                <div className="summary-panel">
                                    <h2 className="summary-title">Podsumowanie do zamówienia</h2>

                                    <div className="price-box">
                                        <div className="price-header">
                                            <h3 className="plan-name">Promowanie {selectedPlan}</h3>
                                            <span className="plan-price">{total.toFixed(2)} zł</span>
                                        </div>

                                        <div className="price-details">
                                            <div className="price-row">
                                                <span>Kwota netto</span>
                                                <span>{basePrice.toFixed(2)} zł</span>
                                            </div>
                                            <div className="price-row">
                                                <span>Podatek VAT (23%)</span>
                                                <span>{vat.toFixed(2)} zł</span>
                                            </div>
                                            <div className="price-row total">
                                                <span>Do zapłaty</span>
                                                <span>{total.toFixed(2)} zł</span>
                                            </div>
                                        </div>
                                    </div>

                                    <p className="info-text">
                                        Potwierdzając przycisk “zamawiam”, zamawiasz usługę zgodnie z Regulaminem Mapen.com
                                    </p>

                                    <button className="order-button">Zamawiam</button>

                                    <p className="legal-text">
                                        Jeśli przysługują Ci prawa konsumenta: realizacja kodu aktywacyjnego spowoduje, że prawo do odstąpienia od zamówienia w terminie 14 dni od jego złożenia nie będzie Ci przysługiwało.
                                    </p>

                                    <p className="legal-text">
                                        Administratorem Twoich danych osobowych dla celów rozliczenia płatności oraz realizacji zamówienia jest: Mapen Sp. z o.o., ul. Strumykowa 19A / 29, 03-138 Warszawa, NIP 5243034036
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}